export const GET_COMPONENT_TEMPLATE = 'GET_COMPONENT_TEMPLATE'
export const ADD_COMPONENT_TEMPLATE = 'ADD_COMPONENT_TEMPLATE'
export const EDIT_COMPONENT_TEMPLATE = 'EDIT_COMPONENT_TEMPLATE'
export const DELETE_COMPONENT_TEMPLATE = 'DELETE_COMPONENT_TEMPLATE'
export const SET_COMPONENT_TEMPLATE = 'SET_COMPONENT_TEMPLATE'

export const UPDATE_LOADING_STATUS = 'UPDATE_LOADING_STATUS'
